import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/editBillToPartyAndVatPartner';

export const setRowData = (payload: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.SET_ROW_DATA, payload });
    };
};

export const updateRowData = (payload: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.UPDATE_ROW_DATA, payload });
    };
};

export const setTargetType = (payload: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.SET_TARGET_TYPE, payload });
    };  
};

export const setJobId = (payload: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.SET_JOB_ID, payload });
    };
};

export const setTarget = (payload: string | number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.SET_TARGET, payload });
    };
};

export const setEditVatMode = (payload: boolean) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.SET_EDIT_VAT_MODE, payload });
    };
};

export const setEditVatOnlyMode = (payload: boolean) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.SET_EDIT_VAT_ONLY_MODE, payload });
    };
};